import * as Sentry from '@sentry/react';

/**
 * Captures an exception to Sentry with optional context.
 * Use in catch blocks to ensure all caught errors are reported.
 */
export function captureException(
  err: unknown,
  context?: { extra?: Record<string, unknown>; tags?: Record<string, string> }
) {
  Sentry.captureException(err, {
    extra: context?.extra,
    tags: context?.tags,
  });
}
